import React, {useEffect, useState, Fragment, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';

const BABusinessListing = ({
                               history,
                               businessListing,
                               businessList = [],
                               fetchZones,
                               getFetchZones = null,
                               getListFilterData,
                               filterDropdownList = []
                           }) => {
    const headers = [
        'Lead Number',
        'Business Name',
        'City',
        'Created By',
        // 'Lead Category',
        'Assigned To',
        'Creation On',
        // 'Status',
        'Actions',
    ];
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [isStatusSuccess, setIsStatusSuccess] = useState(false);
    const [isRoleId, setIsRoleId] = useState(null);
    const {baseUrl} = useContext(BaseUrl);

    useEffect(() => {
        (async () => {
            const roles = await JSON.parse(localStorage.getItem('roles'));
            roles && setIsRoleId(roles[0].pivot.role_id);
        })();
    }, []);


    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await businessListing(1, filterData)
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        const tableData = [
            'id',
            'lead_number',
            'client_name',
            'city_name',
            'name',
            'assigned_name',
            'created_at',
            // 'status',
        ];

        if (businessList !== {} && businessList.data) {
            const data = businessList.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})),
                    {
                        Action: [
                            // {name: 'View POC', link: `/dashboard/brand-activation/viewPoc/BA`},
                            {
                                name: 'View Helper',
                                link: `/dashboard/brand-activation/helper-list/${element['lead_id']}`
                            },
                            {
                                name: 'Ledger',
                                link: `/dashboard/ledger-listing/${element['rb_id']}`
                            },
                        ],
                    }
                )
            );
            data && setListData(data);
            setPageCount(Math.ceil(businessList.total / businessList.per_page));
        }
    }, [businessList]);

    const applyFilter = async (filterData) => {
        localStorage.setItem("businessList", JSON.stringify(filterData));
        setIsLoading(true);
        setFilterData(filterData);
        await businessListing(1, filterData);
        setIsLoading(false);
        filterToggle();
    };

    useEffect(() => {
        (async () => {
            await getListFilterData(2);
        })();
    }, []);

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const headerBtns = () => {
        return (
            <Fragment>
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                >
                    <img src={Images?.Filter} alt=""/>
                    {localization.showFilters}
                </Button>
            </Fragment>
        );
    };

    const onPageChange = async (val) => {
        let filter = filterData === null ? null : filterData;
        setIsLoading(true);
        await businessListing(val.selected + 1, filter);
        localStorage.setItem('page', val.selected + 1)
        setIsLoading(false);
    };

    const getZones = (val) => {
        if (val) fetchZones(val);
    };

    const closeSuccess = () => {
        setIsLoading(true);
        setIsStatusSuccess(!isStatusSuccess);
        setIsLoading(false);
    };

    return (
        <Layout
            title={localization.postSalesLeadListing}
            Buttons={headerBtns}
            isLoading={isLoading}
        >
            <TableSection
                data={listData}
                isId={false}
                headers={headers}
                detailList={businessList && businessList.data}
                pageCount={pageCount}
                srNo={businessList?.from}
                onPageChange={onPageChange}
                currentPage={localStorage.getItem('page')}
            />

            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                // getZones={(val) => getZones(val)}
                listFilterData={filterDropdownList && filterDropdownList.data}
                // zones={getFetchZones && getFetchZones.data}
                isRoleId={isRoleId}
                BaBusinessListFilter={true}
            />

            <ModalPop
                title={localization.updatedSuccessfully}
                show={isStatusSuccess}
                handleModalHide={closeSuccess}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt=""/>
                    </div>
                    <h5>{localization.leadStatusupdatedsuccessfully}</h5>
                    <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
                        {localization.continue}
                        <img src={Images?.ArrowRight} alt=""/>
                    </Link>
                </div>
            </ModalPop>
        </Layout>
    );
};

export default BABusinessListing;
